import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["text", "icon", "copied"]

  connect() {
    console.log("Admin CLIPBOARD controller loaded")
  }

  copy() {
    navigator.clipboard.writeText(this.textTarget.textContent.trim()).then(() => {
      // Switch icon to solid
      this.iconTarget.classList.remove("fa-regular")
      this.iconTarget.classList.add("fa-solid")

      // Show "Kopiert" text
      this.copiedTarget.hidden = false

      // Reset after 1 second
      setTimeout(() => {
        this.iconTarget.classList.remove("fa-solid")
        this.iconTarget.classList.add("fa-regular")
        this.copiedTarget.hidden = true
      }, 1000)
    })
  }

}